export const RobotTableColumns = [
  {
    label: "机器人名称",
    value: "name"
  },
  {
    label: "机器人Token",
    value: "dingRobotToken"
  },
  {
    label: "机器人秘钥",
    value: "dingRobotSecret"
  }
]

export const projectIcons = [
  "folder",
  "people",
  "write",
  "card",
  "filter",
  "bag",
  "lamp",
  "wallet",
  "cloud",
  "rise",
  "branch",
  "chart",
  "store",
  "database",
  "tag",
  "data-line",
  "phone",
  "chat",
  "chart-bar",
  "world",
  "list",
  "rmb",
  "resume",
  "map",
  "headphone",
  "location",
  "horn",
  "building",
  "change",
  "letter",
  "security",
  "paper-plane",
  "cup",
  "pass",
  "spanner",
  "item"
]
